export const BREAKPOINT_SM = 'sm'
export const BREAKPOINT_LG = 'lg'
